import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  EDITENDPOINT: string = environment.EDITENDPOINT;
  public httpOptions = {};
  constructor(private http: HttpClient, private Http: HttpClient) {}

  get(
    url: string,
    headerType: string,
    params?: any,
    type?: any,
  ): Observable<any> {
    let apiEndPoint = this.EDITENDPOINT;

    const headers = this.getHeaders(headerType);

    if (params != null) {
      params = '?' + params;
    } else {
      params = '';
    }

    if (type == 'blob') {
      let fileExtension = { type: 'text/csv;charset=utf-8' };
      return this.http
        .get(apiEndPoint + url + params, { ...headers, responseType: 'text' })
        .pipe(map((res: any) => new Blob([res], fileExtension)));
    }
    if (type == 'xml') {
      let xmlFile = { type: 'text/xml' };
      return this.http
        .get(apiEndPoint + url + params, { ...headers, responseType: 'text' })
        .pipe(map((res: any) => new Blob([res], xmlFile)));
    } else {
      return this.http
        .get(apiEndPoint + url + params, headers)
        .pipe(map((res: any) => res));
    }
  }

  post(
    url: string,
    headerType: string,
    params?: any,
    type = null
  ): any {
    let apiEndPoint = this.EDITENDPOINT;

    let header = this.getHeaders(headerType);

    if (type == 'blob') {
      return this.http
        .post(apiEndPoint + url, params, header)
        .pipe(
          map(
            (res: any) =>
              new Blob([res.blob()], { type: 'text/csv;charset=ISO-8859-1' })
          )
        );
    } else {
      return this.http
        .post(apiEndPoint + url, params, header)
        .pipe(map((res: any) => res));
    }
  }
  delete(
    url: string,
    headerType: string,
    params?: any,
    type = null
  ): any {
    let apiEndPoint = this.EDITENDPOINT;

    let header = this.getHeaders(headerType);
    {
      return this.http
        .delete(apiEndPoint + url, header)
        .pipe(map((res: any) => res));
    }
  }

  uploadFile(
    url: string,
    headerType: string,
    formData?: any
  ): any {
    let apiEndPoint = this.EDITENDPOINT;

    let header = this.getHeaders(headerType);
    return this.Http.put(apiEndPoint + url, formData, header);
  }

  put(
    url: any,
    headerType: any,
    param?: any,
    type = null
  ): Observable<any> {
    let apiEndPoint = this.EDITENDPOINT;

    let header = this.getHeaders(headerType);
    if (type == 'blob') {
      return this.http
        .put(apiEndPoint + url, param, header)
        .pipe(
          map(
            (res: any) =>
              new Blob([res.blob()], { type: 'text/csv;charset=ISO-8859-1' })
          )
        );
    } else {
      return this.http
        .put(apiEndPoint + url, param, header)
        .pipe(map((res: any) => res));
    }
  }

  patch(
    url: any,
    headerType: string,
    param?: any,
    type = null
  ): Observable<any> {
    let apiEndPoint = this.EDITENDPOINT;

    let header = this.getHeaders(headerType);
    if (type == 'blob') {
      return this.http
        .patch(apiEndPoint + url, param, header)
        .pipe(
          map(
            (res: any) =>
              new Blob([res.blob()], { type: 'text/csv;charset=ISO-8859-1' })
          )
        );
    } else {
      return this.http
        .patch(apiEndPoint + url, param, header)
        .pipe(map((res: any) => res));
    }
  }

  getHeaders(headerType: string): any {
    const token = localStorage.getItem('token');
    const token1 = token?.replace(/^"(.*)"$/, '$1');

    switch (headerType) {
      case 'basic':
        this.httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: '' + token,
          }),
        };
        break;
      case 'bearer':
        this.httpOptions = {
          headers: new HttpHeaders({ Authorization: 'bearer ' + token1 }),
        };
        break;
      case 'fileUpload':
        this.httpOptions = {
          headers: new HttpHeaders({
            
            Authorization: 'bearer ' + token,
          }),
        };
        break;
      case 'download':
        this.httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/csv',
            Authorization: 'bearer ' + token,
          }),
        };
        break;
      default:
        break;
    }
    return this.httpOptions;
  }
}
